<section class="col-6 col-sm-6 col-md-3 col-lg-2 landingNavDescription" ipsPermission="main.myproducts">
    <a class="landingNavLink" uiSref="main.myproducts">
        <div class="myProductsImg landingNavIcon"></div>
        <h3 translate>MY_PRODUCTS</h3>
    </a>
</section>
